<template>
    <div id="bene-select-country-container">
        <f7-list form class="form-group">
            <f7-list-input
                input-id     ="homeCountry"
                id           ="homeCountryInput"
                name         ="homeCountry"
                class        ="clickable-row use-chevron"

                :label       ="$t('beneficiary-country')"
                :placeholder ="$t('beneficiary-select-country')"
                :value       ="homeCountryName"
                @change      ="changeHomeCountry($event.target.value);"

                outline
                floating-label
            >
                <f7-link no-link-class popover-open=".popover-home-country" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownHomeCountry" class="popover-home-country dropdown-with-image-2 dropdown beneficiary" vertical-position="bottom" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#" v-for="hc in homeCountryList" :key="hc.id" :selected="hc.id == homeCountryId" @click="changeHomeCountry(hc.id)">
                        {{hc.name}}<img :src="getFlagImg(hc.id)" class="ml-sm"/>
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="transactionType"
                id           ="transactionInput"
                name         ="transactionType"
                class        ="clickable-row use-chevron"

                :label       ="$t('beneficiary-transfer-type')"
                :placeholder ="$t('beneficiary-select-transfer-type')"
                :value       ="transactionTypeName"
                @change      ="changeTransactionType($event.target.value)"

                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-tx-type" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownTxType" class="popover-dropdown-tx-type dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="item in transactionTypeList"
                    :key="item.key"
                    selected=""
                    @click="changeTransactionType(item.key);">
                        {{$t('general-text-tt-'+ item.key)}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'homeCountryList',
                'homeCountryId',
                'homeCountryName',
                'transactionTypeList',
                'transactionTypeId',
                'transactionTypeName',
                'homeIDD',
                'mobileIDD',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setHomeCountry',
                'setHomeCountry',
                'setTransactionType',
                'setHomeIDD',
                'setMobileIDD',
                'loadAddressConfig',
            ]),

            handleChange(e) {
                alert("e: "+e.target.value)
                //homeCountryId = $event.target.value; changeHomeCountry($event.target.value); validateInput($event.target)
            },

            changeHomeCountry(countryId) {
                const self            = this;
                const homeCountryList = self.homeCountryList;

                let isNewHomeCountry = false;
                const oldHomeCountryId = self.homeCountryId;
                if(oldHomeCountryId != countryId) {
                    isNewHomeCountry = true;
                }

                self.$emit("resetFormData", {isNewHomeCountry: isNewHomeCountry});

                Object.keys(homeCountryList).forEach(key => {
                    if(homeCountryList[key].id == countryId) {
                        self.setHomeCountry({id: homeCountryList[key].id, idd: homeCountryList[key].idd, name: homeCountryList[key].name});

                        if(isNewHomeCountry) { // reset tx type
                            self.setTransactionType({id: 0, name: ''});
                        }
                        return;
                    }
                })

                if(self.homeCountryId > 0) {
                    self.setHomeIDD({
                        id: self.homeCountryId
                    });
                    self.setMobileIDD({
                        id: self.homeCountryId
                    });

                    self.$emit("loadTransactionTypeList", {isNewHomeCountry: isNewHomeCountry});

                    // DR-1845 - refresh whether Beneficiary Country / Town-City is
                    // mandatory for the newly selected destination country.
                    self.loadAddressConfig(self.homeCountryId);
                }

            },

            changeTransactionType(txTypeId) {
                this.$emit("changeTransactionType", txTypeId);
            }
        }
    }
</script>